<template>
  <div class="detail-page">
    <div class="header">
      <button class="back-btn" @click="goBack">←</button>
      <span class="title">结算详情</span>
      <span class="placeholder"></span>
    </div>

    <div class="scroll-container">
      <div v-if="!detail.name && !detail.merchantName" class="empty-state">
        <van-icon name="order-o" size="80" color="#4A90D9" />
        <span>暂无结算详情</span>
      </div>

      <div v-else>
        <div class="info-card">
          <div class="info-row">
            <span class="label">结算项目</span>
            <span class="value">{{ detail.name }}</span>
          </div>
          <div class="info-row">
            <span class="label">结算企业</span>
            <span class="value">{{ detail.merchantName }}</span>
          </div>
          <div class="info-row">
            <span class="label">结算时间</span>
            <span class="value">{{ detail.endTime }}</span>
          </div>
          <div class="info-row">
            <span class="label">结算金额</span>
            <span class="value amount">{{ detail.salaryRange }}</span>
          </div>
          <div class="info-row">
            <span class="label">备注</span>
            <span class="value">{{ remark }}</span>
          </div>
          <div class="info-row">
            <span class="label">结算说明</span>
            <span class="value">{{ detail.describe }}</span>
          </div>
        </div>

        <div class="upload-card">
          <div class="upload-title">上传凭证</div>
          <div class="upload-area">
            <div
              class="upload-placeholder"
              :class="{ 'uploading-disabled': uploading }"
              @click="!uploading && triggerUpload()"
            >
              <van-loading v-if="uploading" size="32" color="#4f7cff" />
              <van-icon v-else name="plus" size="32" color="#4f7cff" />
              <span class="upload-text">{{
                uploading ? "上传中..." : "上传图片"
              }}</span>
            </div>

            <div
              v-for="item in localUploads"
              :key="item.id"
              class="uploaded-preview"
            >
              <img
                :src="item.base64 || item.filePath"
                alt="凭证"
                class="preview-image"
              />
              <div v-if="item.status === 'uploading'" class="mask">
                <van-loading size="24" color="#fff" />
              </div>
              <!-- <div v-else-if="item.status === 'error'" class="mask error">
                <span>失败</span>
              </div> -->
              <button class="remove-btn" @click="removeLocalUpload(item.id)">
                ✕
              </button>
            </div>
          </div>
          <input
            type="file"
            ref="fileInput"
            accept="image/*"
            class="hidden-input"
            @change="handleFileChange"
          />
        </div>

        <!-- 已上传凭证（后端返回的历史记录） -->
        <div class="existing-files" v-if="files.length > 0">
          <div class="files-title">已上传凭证</div>
          <div class="files-list">
            <div v-for="file in files" :key="file.id" class="file-item">
              <img
                :src="file.filePath"
                :alt="file.fileName"
                class="file-image"
              />
              <span class="file-name">{{ file.fileName }}</span>
            </div>
          </div>
        </div>

        <!-- 底部提交按钮（70%宽度） -->
        <div class="footer" style="margin: 10px 0 70px 0">
          <button
            class="submit-btn-footer"
            :disabled="!canSubmit"
            @click="submitFiles"
          >
            {{ submitting ? "提交中..." : "提交凭证" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import { httpPost, httpPostForm, BASE_URL } from "@/utils/fetch";

const STORAGE_KEY = "uploaded_file_paths";

export default {
  name: "SettlementDetail",
  data() {
    return {
      routeId: "",
      detailId: null,

      detail: {
        name: "",
        merchantName: "",
        endTime: "",
        salaryRange: "",
        describe: "",
      },
      remark: "",
      files: [], // 后端返回的已有凭证
      localUploads: [], // 本次上传的凭证（含预览）
      uploading: false,
      submitting: false,
    };
  },
  computed: {
    // ★ 提交按钮启用条件：必须有详情ID，且至少有一张成功上传的凭证
    canSubmit() {
      if (!this.detailId) return false;
      return this.localUploads.some((item) => item.status === "success");
    },
    successFilePaths() {
      return this.localUploads
        .filter((item) => item.status === "success" && item.filePath)
        .map((item) => item.filePath);
    },
  },
  mounted() {
    // 获取路由传入的ID（仅作为请求详情的参数）
    this.routeId = this.$route.query.id || this.$route.params.id;

    // ★ 真实接口调用
    if (this.routeId) {
      this.fetchDetail();
    } else {
      Toast.fail("缺少结算ID");
    }
  },
  methods: {
    goBack() {
      this.$router.back();
    },

    // ================================================================
    // ★ 真实接口请求
    // ================================================================
    fetchDetail() {
      httpPost("/wechat/wechat/getOneDeliveryFile", { signUpId: this.routeId })
        .then((data) => {
          if (data.code === "0000") {
            var resData = data.data || {};
            var detail = resData.detail || {};
            // ★★★ 关键：从详情返回数据中提取实际ID（字段名根据接口调整） ★★★
            this.detailId = resData.id || detail.id || null;
            this.detail = {
              name: detail.name || "",
              merchantName: detail.merchantName || "",
              endTime: detail.endTime || "",
              salaryRange: detail.salaryRange || "",
              describe: detail.describe || "",
            };
            this.remark = resData.remark || "";
            this.files = resData.files || [];
            if (this.files.length > 0) {
              localStorage.removeItem(STORAGE_KEY);
            }
          } else {
            Toast.fail(data.message || "获取详情失败");
          }
        })
        .catch((error) => {
          Toast.fail("获取详情失败，请稍后重试");
          console.error("获取详情失败:", error);
        });
    },

    triggerUpload() {
      this.$refs.fileInput.click();
    },

    handleFileChange(e) {
      var file = e.target.files[0];
      if (!file) return;

      if (!file.type.startsWith("image/")) {
        Toast.warning("请上传图片格式文件");
        return;
      }

      const tempId = Date.now() + Math.random();

      const reader = new FileReader();
      reader.onload = (ev) => {
        const base64 = ev.target.result;
        this.localUploads.push({
          id: tempId,
          base64: base64,
          fileName: file.name,
          status: "uploading",
          filePath: "",
        });
        this.uploadFile(file, tempId);
      };
      reader.readAsDataURL(file);

      e.target.value = "";
    },

    uploadFile(file, tempId) {
      this.uploading = true;
      Toast.loading("上传中...");

      var formData = new FormData();
      formData.append("file", file);

      var token = localStorage.getItem("wechat_token") || "";

      fetch(BASE_URL + "/wechat/wechat/picZip", {
        method: "POST",
        headers: { token: token },
        body: formData,
      })
        .then((response) => response.json())
        .then((result) => {
          this.uploading = false;
          Toast.clear();

          const index = this.localUploads.findIndex(
            (item) => item.id === tempId
          );
          if (index === -1) return;

          if (result.code === "0000") {
            const filePath = result.data && result.data.filePath;
            if (!filePath) {
              this.localUploads[index].status = "error";
              Toast.fail("上传成功但未返回文件路径");
              return;
            }

            this.localUploads[index].status = "success";
            this.localUploads[index].filePath = filePath;

            // 存储到本地缓存（仅供备用，提交时不依赖它）
            this.saveFilePathToLocal(filePath);
            Toast.success("上传成功");
          } else {
            this.localUploads[index].status = "error";
            Toast.fail(result.message || "上传失败");
          }
        })
        .catch((error) => {
          this.uploading = false;
          Toast.clear();
          Toast.fail("上传失败，请稍后重试");
          console.error("上传异常:", error);
          const index = this.localUploads.findIndex(
            (item) => item.id === tempId
          );
          if (index !== -1) {
            this.localUploads[index].status = "error";
          }
        });
    },

    saveFilePathToLocal(filePath) {
      try {
        let paths = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
        paths.push(filePath);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(paths));
      } catch (e) {
        console.warn("存储本地路径失败:", e);
      }
    },

    removeLocalUpload(id) {
      this.localUploads = this.localUploads.filter((item) => item.id !== id);
    },

    // ★★★★★ 提交凭证 ★★★★★
    submitFiles() {
      if (!this.canSubmit) {
        if (!this.detailId) {
          Toast.fail("缺少结算ID，无法提交");
        } else {
          Toast.fail("请先上传至少一张凭证");
        }
        return;
      }

      this.submitting = true;
      Toast.loading("提交中...");

      // ★★★ 关键：使用 detailId（详情返回的ID）作为 signUpload ★★★
      const params = {
        signUpload: this.detailId,
        files: this.successFilePaths,
      };

      httpPost("/wechat/wechat/addDeliveryFile", params)
        .then((res) => {
          this.submitting = false;
          Toast.clear();
          if (res.code === "0000") {
            Toast.success("凭证提交成功");
            this.$router.back(); // 返回列表页
          } else {
            Toast.fail(res.message || "提交失败");
          }
        })
        .catch((error) => {
          this.submitting = false;
          Toast.clear();
          Toast.fail("提交异常，请稍后重试");
          console.error("提交凭证异常:", error);
        });
    },
  },
};
</script>

<style scoped>
/* 样式完全不变，与用户提供的一致 */
.detail-page {
  min-height: 100vh;
  background: #f4f7fd;
  display: flex;
  flex-direction: column;
}

.header {
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  flex-shrink: 0;
}

.back-btn {
  width: 36px;
  height: 36px;
  border: none;
  background: #f5f7fa;
  border-radius: 50%;
  font-size: 20px;
  color: #333;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.back-btn:active {
  background: #e8ecf2;
}

.title {
  font-size: 18px;
  font-weight: 600;
  color: #0b1a33;
}
.placeholder {
  width: 36px;
}

.scroll-container {
  flex: 1;
  overflow-y: auto;
  padding: 16px;
}

.info-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}

.info-row {
  display: flex;
  padding: 12px 0;
  border-bottom: 1px solid #f5f7fa;
}
.info-row:last-child {
  border-bottom: none;
}

.label {
  width: 90px;
  flex-shrink: 0;
  font-size: 14px;
  color: #7a88a6;
}
.value {
  font-size: 14px;
  color: #1a2332;
}
.amount {
  color: #e74c5e;
  font-weight: 600;
}

.upload-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}

.upload-title {
  font-size: 16px;
  font-weight: 600;
  color: #0b1a33;
  margin-bottom: 16px;
}

.upload-area {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
}

.upload-placeholder {
  width: 120px;
  height: 120px;
  border: 2px dashed #d9d9d9;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: border-color 0.2s, background 0.2s;
  flex-shrink: 0;
}
.upload-placeholder:active:not(.uploading-disabled) {
  border-color: #4f7cff;
  background: #f5f9ff;
}
.upload-placeholder.uploading-disabled {
  cursor: not-allowed;
  opacity: 0.7;
}
.upload-text {
  font-size: 13px;
  color: #909399;
  margin-top: 4px;
}

.uploaded-preview {
  width: 120px;
  height: 120px;
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  border: 2px solid #e8ecf2;
  flex-shrink: 0;
}
.preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.remove-btn {
  position: absolute;
  top: -8px;
  right: -8px;
  width: 24px;
  height: 24px;
  border: none;
  background: #ff4d4f;
  color: #fff;
  border-radius: 50%;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}
.mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 14px;
}
.mask.error {
  background: rgba(255, 0, 0, 0.5);
}

.existing-files {
  background: #ffffff;
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}

.files-title {
  font-size: 16px;
  font-weight: 600;
  color: #0b1a33;
  margin-bottom: 16px;
}

.files-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}
.file-item {
  width: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.file-image {
  width: 100px;
  height: 100px;
  border-radius: 8px;
  object-fit: cover;
  margin-bottom: 6px;
}
.file-name {
  font-size: 12px;
  color: #7a88a6;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
}

.footer {
  padding: 16px 0 20px;
  display: flex;
  justify-content: center;
  background: transparent;
  box-shadow: none;
  position: static;
}

.submit-btn-footer {
  width: 70%;
  height: 48px;
  border: none;
  background: #4f7cff;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border-radius: 24px;
  cursor: pointer;
  transition: opacity 0.2s;
}
.submit-btn-footer:active:not(:disabled) {
  opacity: 0.8;
}
.submit-btn-footer:disabled {
  background: #c0c4cc;
  cursor: not-allowed;
  opacity: 0.6;
}

.hidden-input {
  display: none;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 100px 20px;
  gap: 16px;
  color: #8a99b0;
  font-size: 16px;
}
.empty-state .van-icon {
  opacity: 0.5;
  margin-bottom: 8px;
}

@media (max-width: 480px) {
  .header {
    padding: 12px 16px;
  }
  .scroll-container {
    padding: 12px;
  }
  .info-card {
    padding: 16px;
  }
  .label {
    width: 76px;
  }
  .footer {
    padding: 12px 0 16px;
  }
}
</style>